export default __webpack_public_path__ + "static/media/gallery_03.5833552b.jpg";